import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getProfileData } from '../../modules/details.ducks';
import AccountsEcardPrintable from '../../ui-componets/accounts-ecard-printable';
import { getPrintableCard, getProductStatus, getConfigData, updateEcardId } from '../../modules/details.ducks';
import { getAddressList} from "../../modules/addresses.ducks";
import Button from '../../ui-componets/button';
import EpointsPrice from "../../ui-componets/epoints-price";
import QS from "query-string";
import Moment from 'react-moment';
import Loader from '../../ui-componets/loader';
import { useTranslation } from 'react-i18next';
import { useTokenAuth } from '../../hooks/useTokenAuth';


interface IProps {
    history: any
    printableId: any;
    getPrintableCard: any
    printableData: any
    getProfileData: any
    getAddressList: any
    addressList: any
    getProductStatus: any
    ecardStatus: any
    ecardRedirectId: any
    getConfigData: any
    configResponse: any
    updateEcardId: any
    tokenDetails:any
    global:any
    isEcardFetching: boolean
    isUserFetching: boolean
}

function EcardsPrint(props: IProps) {
    const { getPrintableCard, printableData, getProfileData, getAddressList, getProductStatus, ecardStatus, getConfigData, isEcardFetching, isUserFetching } = props;
    const { t } = useTranslation();
    useEffect(() => {
        window.scrollTo(0, 0);
        getProfileData();
        getAddressList();
        getConfigData();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // get sso object from localStorage
    let ssoData = props.global.SSO_USER;
    let isSsoUser = ssoData?.enabled;

    // Use reusable token authentication hook
    useTokenAuth('/profile/my-account/ecards/ecard', props.global, props.tokenDetails, props.history);

    useEffect(() => {
        handleId();
    }, [props.tokenDetails]);

    const handleId = () =>{
        let ssoEcardId = localStorage.getItem('ssoecardId');
        const ecardId = QS.parse(window.location.search).id
        if(QS.parse(window.location.search).id){
            getPrintableCard(ecardId);
            getProductStatus(ecardId);
        } else if(QS.parse(window.location.search).state){
            let id= QS.parse(window.location.search).state
            getPrintableCard(id);
            getProductStatus(id);
        } else if(isSsoUser && ssoEcardId){
            getPrintableCard(ssoEcardId);
            getProductStatus(ssoEcardId);
        }
    }

    const handleClaimReward = () =>{
        let ssoEcardId = localStorage.getItem('ssoecardId');
        let ecardId ;
        if(QS.parse(window.location.search).id){
            ecardId = QS.parse(window.location.search).id;
        } else if(QS.parse(window.location.search).state){
            ecardId = QS.parse(window.location.search).state
        } else if(isSsoUser && ssoEcardId){
            ecardId = ssoEcardId;
        }
        
        switch (ecardStatus.action) {
            case 'REDEEMABLE':
                props.history.push(`/my-account/ecards/getreward/?id=${ecardId}`);
                break;
            case 'ORDER_FULFILLED':
                props.history.push(`/my-account/ecards/getreward/?id=${ecardId}`);
                break;
            case 'POINTS_EXCHANGED':
                props.history.push(`/my-account/ecards/getreward/?id=${ecardId}`);
                break;
            case 'EXCHANGE_FOR_POINTS':
                props.history.push(`/my-account/ecards/getreward/?id=${ecardId}`);
                break;
            default:
        }
    }

    const handlePrint = () => {
        window.print();
    }
    
    return (
        <div>
        { isUserFetching || isEcardFetching || isEcardFetching === undefined ?
      <div>
          <Loader/>
      </div>:
        <div id="test" className="ecards-prints">
            <div className="ecards-print-binder">
                {printableData &&
                    <div className="prinatable-data-biunder">
                        <div className="flex-total-print">
                            <div className="printable-head">
                                <div className="flexing-print">
                                    <p className="time-print font-styleRegular m-0">
                                    <Moment fromNow>{printableData.createdAt}</Moment>
                                        </p>
                                </div>
                                <div className="flexing-print-from">
                                    <p className="textprint font-styleBold m-0 font-16">{t('from')} {printableData?.from?.firstName} {printableData?.from?.lastName}</p>
                                </div>
                            </div>
                           
                            <div className="claiming">
                                <div className="claiming-sub">
                                {ecardStatus && ecardStatus.pointsValue >0 && printableData.awardType === 'product' &&
                                    <Button
                                        label={t("Claim reward")}
                                        
                                        width="141px"
                                        type="primary"
                                        onClick={handleClaimReward}
                                    />
                                    }
                                </div>
                                <div className="claiming-sub">
                                {printableData && printableData.awardType !== 'product' && printableData.pointsValue > 0 &&
                                    <div>
                                    <EpointsPrice
                                        epoints={printableData.pointsValue}
                                        price={0}
                                        size="small"
                                    />
                                    </div>
}
                                </div>
                            </div>
                        </div>
                        <AccountsEcardPrintable printableData={printableData} />
                        <div className="print-btn" >
                            <Button
                                label={t("Print")}
                                
                                width="141px"
                                type="secondary"
                                onClick={handlePrint}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
}
</div>
    );
}

const mapStateToProps = (state: any) => ({
    userPersonalDetails: state.details.profileData.userSubscriptionDetails,
    tokenDetails: state.join.tokens,
    global: state.global,
    loginDetails: state.join.loginDetails,
    printableData: state.details.printEcardData,
    addressList: state.address.addresses,
    ecardStatus: state.details.productDetails,
    isEcardFetching: state.details.isEcardFetching,
    isUserFetching: state.ui.isUserFetching,
    configResponse: state.details.configData
});

export default connect(mapStateToProps, { getProfileData, getPrintableCard, getAddressList, getProductStatus, getConfigData, updateEcardId })(EcardsPrint);